import firebase from "firebase";

var firebaseConfig = {
    apiKey: 'AIzaSyB7L7m-3u-xTgCNSUvb4UtgHSCWsxVi-qI',
    authDomain: '<your-project-authdomain>',
    databaseURL: 'https://sneos-app.firebaseio.com/',
    projectId: 'sneos-app',
    storageBucket: '<your-storage-bucket>',
    messagingSenderId: '<your-messaging-sender-id>'
};

export default firebase.initializeApp(firebaseConfig);